import API from 'services/TAPS_API/index';

export default function getFileCategories(queryParams) {
  return API.request({
    method: 'GET',
    url: `/dictionary/fileCategories`,
    params: queryParams,
  });
}
